import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/oj-logo.jpg'


const _hoisted_1 = { id: "HomeView" }
const _hoisted_2 = { style: {"margin-bottom":"2rem","text-align":"center"} }
const _hoisted_3 = { style: { marginBottom: '12px' } }

import MdViewer from "@/components/MdViewer.vue";
import content from "@/assets/index.md"; // 使用 import 引入 md
import {
  IconCodeSquare,
  IconFile,
  IconFire,
  IconGithub,
  IconMindMapping,
} from "@arco-design/web-vue/es/icon";


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const pendingProps = {
  pending: "Comming Soon...",
};

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_timeline_item = _resolveComponent("a-timeline-item")!
  const _component_a_link = _resolveComponent("a-link")!
  const _component_a_timeline = _resolveComponent("a-timeline")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[9] || (_cache[9] = _createElementVNode("h1", null, "Online Judge", -1)),
    _createVNode(_component_a_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 14 }, {
          default: _withCtx(() => [
            _createVNode(MdViewer, {
              value: _unref(content) || ' '
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 10 }, {
          default: _withCtx(() => [
            _cache[8] || (_cache[8] = _createElementVNode("img", {
              alt: "logo",
              src: _imports_0,
              style: {"display":"block","margin":"0 auto"}
            }, null, -1)),
            _createElementVNode("h2", _hoisted_2, [
              _createVNode(_unref(IconMindMapping)),
              _cache[0] || (_cache[0] = _createTextVNode(" 建站时间线 "))
            ]),
            _createVNode(_component_a_timeline, _mergeProps({
              "label-position": "relative",
              mode: "alternate"
            }, pendingProps), {
              dot: _withCtx(() => [
                _createVNode(_unref(IconFire), { style: { color: '#e70a0a' } })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_a_timeline_item, {
                  label: "2024-09-19",
                  lineType: "dashed"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_row, { style: { display: 'inline-flex', alignItems: 'center' } }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IconFile), {
                          size: 32,
                          style: { marginRight: '16px', marginBottom: '12px' }
                        }),
                        _cache[1] || (_cache[1] = _createElementVNode("div", { style: { marginBottom: '12px' } }, "开题报告完成", -1))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_timeline_item, {
                  label: "2024-09-29",
                  lineType: "dashed"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_row, { style: { display: 'inline-flex', alignItems: 'center' } }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IconGithub), {
                          size: 32,
                          style: { marginRight: '16px', marginBottom: '12px' }
                        }),
                        _createElementVNode("div", _hoisted_3, [
                          _cache[3] || (_cache[3] = _createTextVNode(" 建立 ")),
                          _createVNode(_component_a_link, {
                            href: "https://github.com/Cuber-Wei/software-design",
                            icon: ""
                          }, {
                            default: _withCtx(() => _cache[2] || (_cache[2] = [
                              _createTextVNode("GitHub代码仓库 ")
                            ])),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_timeline_item, {
                  label: "2024-10-29",
                  lineType: "dashed"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_row, { style: { display: 'inline-flex', alignItems: 'center' } }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IconFile), {
                          size: 32,
                          style: { marginRight: '16px', marginBottom: '12px' }
                        }),
                        _cache[4] || (_cache[4] = _createElementVNode("div", { style: { marginBottom: '12px' } }, "需求获取报告完成", -1))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_timeline_item, {
                  label: "2024-11-07",
                  lineType: "dashed"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_row, { style: { display: 'inline-flex', alignItems: 'center' } }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IconFile), {
                          size: 32,
                          style: { marginRight: '16px', marginBottom: '12px' }
                        }),
                        _cache[5] || (_cache[5] = _createElementVNode("div", { style: { marginBottom: '12px' } }, "需求分析报告完成", -1))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_timeline_item, {
                  label: "2024-11-08",
                  lineType: "dashed"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_row, { style: { display: 'inline-flex', alignItems: 'center' } }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IconCodeSquare), {
                          size: 32,
                          style: { marginRight: '16px', marginBottom: '12px' }
                        }),
                        _cache[6] || (_cache[6] = _createElementVNode("div", { style: { marginBottom: '12px' } }, "前端界面框架基本完成", -1))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_timeline_item, {
                  label: "2024-11-11",
                  lineType: "dashed"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_row, { style: { display: 'inline-flex', alignItems: 'center' } }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IconFile), {
                          size: 32,
                          style: { marginRight: '16px', marginBottom: '12px' }
                        }),
                        _cache[7] || (_cache[7] = _createElementVNode("div", { style: { marginBottom: '12px' } }, "demo预览部署上线", -1))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})